export default {
  Andpenalties: 'Vereffende schadevergoedingen en boetes',
  DeliveryFailed:
    'Levering mislukt, terugbetalingen zijn voor rekening van Partij A',
  abandonedRequests: 'Verlaten bestelling',
  abandonedorder: 'Verlaten bestelling',
  accesshelpcenter: 'Ga naar ons helpcentrum',
  accessoriesLessDelivery:
    'Gebrek aan accessoires, minder levering en terugbetalingen zijn voor rekening van Partij A',
  accesstoken: 'Toegangstoken',
  accessurlexample: 'Voorbeeld: jouw-winkel.com',
  accessurlprefix:
    'De URL mag de volgende waarden niet bevatten: www., https://, http://, /',
  actions: 'Acties',
  activate: 'activeren',
  activateStore:
    'Als u onze Online Store gaat gebruiken, activeer deze dan om alle DNS-records vrij te geven.',
  active: 'ACTIEF',
  active2: 'Actief',
  actuallyPrice: 'Eigenlijk Prijs',
  addDomainTips1: 'Koppel een domein dat al van u is.',
  addDomainTips2:
    'Je kunt ook een subdomein koppelen. Zorg ervoor dat u uw formulier begint met "betalen" of "pago". Ex.:',
  addDomainTips3: 'Niet gebruiken',
  addDomainTips4: 'Houd het in de gaten! zodat uw domein werkt,',
  addDomainTips5: 'u moet een hostingservice aanschaffen en configureren',
  addDomainTips6: 'of een ander.',
  addDomainTips7: 'Als u vragen heeft, raadpleeg dan onze',
  addPopup: 'Coupon toevoegen',
  addastore: 'Voeg een winkel toe',
  addstore: 'Winkel toevoegen',
  afterEachSuccessful:
    'Na elke succesvolle transactie van Partij B zal Partij A 5% van het succesvolle transactiebedrag van Partij B opnemen en de doorlopende marge op de rekening van Partij A behouden terwijl deze wordt overgedragen aan Partij B. De doorlopende marge op de rekening van Partij A voor elke transactie wordt 45 dagen bewaard en het bedrag wordt na 45 dagen vrijgegeven aan Partij B.',
  afterSales:
    'Dit is de after-sales mailbox. Klanten sturen after-salesvragen naar deze mailbox en het after-salesteam zal antwoorden.',
  afterVerification:
    'Als de reden voor terugbetaling na verificatie in de volgende vijf situaties valt, komt de terugbetaling voor rekening van Partij B',
  agreetoNY:
    '"Door een account aan te maken, ga je akkoord met die van USAdrop"',
  alreadyhaveanaccount: 'Heeft u al een account?',
  and: 'En',
  apikey: 'API-sleutel/client-ID',
  apisecretkey: 'API-geheime sleutel / geheim',
  ativo: 'ACTIEF',
  backgroundColor: 'Achtergrondkleur',
  basicinformation: 'Basisinformatie',
  blacklisted:
    'Als de klant op de zwarte lijst staat, wordt de terugbetaling geannuleerd en gedragen door Partij B',
  blacklistedCustomer: 'Klant op de zwarte lijst, terugbetaling annuleren',
  borneByParty:
    'Omdat partij B niet op tijd heeft betaald, verzoekt de klant om de bestelling te annuleren. De terugbetaling komt voor rekening van partij B.',
  borneParty:
    'Als het product niet naar wens is (het niet bevalt), komt de terugbetaling voor rekening van Partij A',
  buttonText: 'Knoptekst',
  cancel: 'annuleren',
  cancellationAnd:
    'Als de bestelling niet wordt verzonden en de klant om annulering en terugbetaling verzoekt, komt de terugbetaling voor rekening van Partij B',
  cardPaymentsAnswer:
    'Zodra de klant op onze rekening betaalt, wordt het de volgende dag naar uw portemonnee overgemaakt.',
  cardPaymentsTitile:
    'Hoe lang duurt het voordat het bedrag op mijn rekening staat nadat klanten een bestelling hebben geplaatst?',
  carddesc: 'KAARTEN, BOLETO, BANKBETALING EN PIX',
  changeAddress:
    'Voor verzoeken om het adres te wijzigen nadat de goederen zijn verzonden, komt de terugbetaling voor rekening van Partij B',
  classic: 'Klassiek',
  collaboratorRequestCode:
    'Machtigingen en codes van medewerkers opslaan（Onze e-mail is _email_, verwerk de toestemming）',
  collapsemenu: 'Menu samenvouwen',
  confirm: 'Bevestigen',
  confirmedAndThe:
    'Als de bestelling moet worden bevestigd en de klant langer dan 2 dagen niet antwoordt, is de terugbetaling ten laste van partij B.',
  confirmpassword: 'Bevestig uw wachtwoord',
  contentTerms: 'Inhoudsvoorwaarden',
  convertedOrderPaid: 'Omgezette bestelling (betaald)',
  convertedOrderUnpaid: 'Omgezette bestelling (onbetaald)',
  copy: 'kopiëren',
  correspondingPenalties:
    'Partij B moet voldoen aan wet- en regelgeving, evenals aan Partij A en de risicobeheereisen van de kaartorganisatie voor illegale transacties. Als Partij B een van deze regels overtreedt, wordt Partij B onderworpen aan overeenkomstige straffen en boetes.',
  countdownImage: 'Aftellen afbeelding',
  countdownTimer: 'Afteltimer',
  countdownBg: 'Achtergrondkleur aftellen',
  countdownTextColor: 'Aftellen Tekstkleur',
  country: 'Land',
  coupon: 'Coupon',
  couponCode: 'Kortingscode (optioneel)',
  creatanaccount: 'Maak een account aan',
  createTime: 'Creëer tijd',
  createaccounttitle:
    'Maak uw gratis account aan op ons Basisabonnement, zonder maandelijkse kosten.',
  createfreeaccount: 'Maak een gratis account aan',
  createpassword: 'Maak een wachtwoord aan',
  currencyConversionAnswer:
    'Omrekenen op basis van de officiële wisselkoers van de betalingsprovider',
  currencyConversionTitle: 'Problemen met valutaconversie？',
  currentStoreName: 'Huidige winkel:',
  customerBuysMore:
    'Als de klant meer koopt en wil annuleren en terugbetalen, komt de terugbetaling voor rekening van Partij B',
  date: 'Datum',
  days: 'dagen',
  defaultDomainTips:
    '"Dit is het gratis domein dat door de USAdrop wordt aangeboden. Het zal altijd werken. Maar we raden aan om je eigen domein op te zetten."',
  delete: 'Verwijderen',
  deleteSelected: 'GESELECTEERDE WISSEN',
  deleteSuccess: 'Verwijdering succesvol!',
  deletedSuccessfully: 'Succesvol verwijderd',
  deliveryTime:
    'De klant ontvangt de goederen, de levertijd is te lang, overschrijding van de winkeltijdlimiet, terugbetalingen zijn ten laste van Partij A',
  disable: 'Uitzetten',
  disabledSuccessfully: 'Succesvol uitgeschakeld',
  discount: 'Korting',
  discountAmount: 'Kortingsbedrag',
  discountPercent: 'Kortingspercentage',
  discountRate: 'Kortingsinstellingen',
  dnsNormal: 'DNS-recordconfiguratie is normaal',
  dnsNotConfigured: 'DNS-record niet geconfigureerd of niet doorgegeven.',
  dnsRecordsTitle: 'DNS-records voor uw online winkel',
  domain: 'Domein',
  domainbtntext: 'Instellen',
  domaintitle: 'Stel hier hetzelfde domein in als uw Shopify-winkel.',
  eachSuccessfulTransaction:
    'Na elke succesvolle transactie van Partij B zal Partij A 10% van het succesvolle transactiebedrag van Partij B opnemen en de doorlopende marge op de rekening van Partij A behouden terwijl deze wordt overgedragen aan Partij B. De doorlopende marge op de rekening van Partij A voor elke transactie wordt 45 dagen bewaard en het bedrag wordt na 90 dagen vrijgegeven aan Partij B.',
  edit: 'Bewerking',
  editstore: 'Winkel bewerken',
  email: 'E-mail',
  emailContent: 'E-mailinhoud',
  emailReminders: 'Promotionele instelling',
  emailRemindersDesc: 'Stel e-mailherinneringen en bestelkortingen in',
  emailTemplateConfig: 'Configuratie van e-mailsjabloon',
  emailTemplateConfigDesc: 'Aangepaste e-mailinhoud',
  emailTitle: 'E-mailonderwerp',
  embedPaymentMethods:
    "Gebruik e-mails om klanten aan te sporen de betaling op verschillende tijdstippen af ​​te ronden om de conversieratio's van bestellingen te verhogen.",
  emptyCouponDesc:
    'Na het configureren van de kortingsbon verschijnt er na het voltooien van de betaling een pop-up waarin u de kortingsbon kunt claimen, waardoor de gebruiker wordt aangemoedigd de kortingsbon te gebruiken voor een betere deal.',
  emptyCouponTitle: 'Configureer uw kortingsbon',
  enable: 'Inschakelen',
  enableCouponTips:
    'Er kan slechts één coupon tegelijk actief zijn. Schakel andere kortingsbonnen uit voordat u doorgaat!',
  enabledSuccessfully: 'Succesvol ingeschakeld',
  end: 'Einde',
  endDate: 'Einddatum',
  enter: 'Binnenkomen',
  entercorrectemail: 'Voer het juiste e-mailformaat in',
  enteremailandpassword: 'Voer uw e-mailadres en wachtwoord in',
  example: 'Voorbeeld',
  faqs: 'Veelgestelde vragen',
  firstPaymentChannel: 'Betaalmethode voor eerste bestelling',
  firsttimeaNY: 'Eerste keer op de USAdrop?',
  followInstructions: 'Volg de instructies',
  followingPenalties:
    'Naast de bovengenoemde boetes worden degenen die de regelgeving ernstig overtreden, geconfronteerd met de volgende straffen:',
  forBrazil: 'Voor Brazilië:',
  forMexico: 'Voor Mexico/Chili/Colombia/Peru:',
  forPaymentFailure:
    'Bij mislukte betaling komt de terugbetaling voor rekening van Partij B',
  forShopify:
    "Wanneer u zich aanmeldt voor Shopify, krijgt uw online winkel de URL 'myshopify.com'.",
  forgetpassword: 'Ik ben mijn wachtwoord vergeten',
  fullname: 'Volledige naam',
  goodsNum: 'artikelen',
  gtm: 'Code (GTM-XXXXXXX)',
  gtmRequired: 'Container-ID is vereist',
  gtmDomain: 'URL van servercontainer',
  gtmDomainRequired: 'Servercontainer-URL is vereist',
  googleid: 'Meting-ID',
  googlekey: 'API-geheimen van het meetprotocol',
  googleidRequired: 'Metings-ID is vereist',
  googlekeyRequired: 'API-geheimen van het Measurement Protocol zijn vereist',
  hasBeenSigned:
    'Uit de logistiek blijkt dat er getekend is, maar de klant heeft deze niet ontvangen, restituties zijn voor rekening van Partij A',
  hasquestions: 'Heeft u vragen?',
  headerImage: 'Kopafbeelding',
  helpCenter: 'Helpcentrum',
  helpaddress: 'bento.me/enchentesrs',
  hi: 'Hoi',
  holding: '1, vasthouden',
  home: 'Thuis',
  howtocontribute: 'Kijk hoe u kunt bijdragen op',
  howtoset: 'Hoe in te stellen',
  identifyyourself: 'Identificeer jezelf',
  imitationBrand: 'Imitatie/imitatie merk',
  inActive: 'INACTIEF',
  inativo: 'INATIVO',
  info: 'Informatie',
  installtitle: 'Installeer USAdrop Transparent Checkout in je Shopify-winkel.',
  invitationNumber: 'Uitnodigingscode',
  invitationNumberError:
    'Voer uw uitnodigingsnummer in om uw registratie te voltooien',
  isConfirmDelete: 'Weet je zeker dat je het wilt verwijderen？',
  kEmail: 'E-mail',
  kName: 'Naam',
  learnMore: 'leer meer.',
  lengthLimit: 'De lengte moet 3 tot 8 zijn',
  letteringPattern:
    'Productkwaliteit (grootte, kleurverschil, schade, vlekken, draaduiteinden, geur, rimpels, vervaging, krimp, belettering, patroon, logo, accessoires), terugbetalingen zijn ten laste van partij A',
  like: 'leuk vinden',
  linkNewDomain: 'Nieuw domein koppelen',
  liquidatedDamages: 'Vereffende schadevergoedingen en boetes.',
  logaccount: 'U bent ingelogd op:',
  loginsuccess: 'succes met inloggen!',
  logout: 'Uitloggen',
  logoutSYS: 'Of u zich moet afmelden bij het systeem?',
  lougoutsuccess: 'Uitloggen Succes!',
  markAsActive: 'Markeer als actief',
  markAsInactive: 'Markeer als inactief',
  min: 'min',
  mydomain: 'Mijn domein',
  mydomains: 'Mijn domeinen',
  mydomainsdesc:
    'Beheer hier uw domeinen. Koppel uw domeinen en configureer ze als het virtuele adres van uw winkel en kassa.',
  name: 'NAAM:',
  needhelp: 'Rio Grande do Sul heeft jouw hulp nodig.',
  newaffiliations: 'Nieuw land',
  newpixel: 'Nieuwe pixel',
  nextPage: 'Volgende pagina',
  backToMessages: 'Terug naar berichten',
  messageDetail: 'Berichtdetails',
  noNotifications: 'Geen meldingen',
  notifications: 'Meldingen',
  refresh: 'Vernieuwen',
  no: 'Nee',
  noDomain: 'Geen domein',
  noStatus: 'Geen status',
  noUseDefaultDomain: 'Gebruik geen USAdrop-standaardbetaaldomein!',
  noUseOrgin: 'Gebruik geen http:// https:// en www',
  nocountriesavailable: 'Geen landen beschikbaar',
  nodatareadtitle: 'Lees ons volledige artikel',
  nodatastartsell:
    'Wanneer u begint met verkopen, verschijnen uw bestellingen hier.',
  nodatatip1: 'Personaliseer uw winkel met de uitstraling van uw bedrijf!',
  nodatatip2: 'Bied verschillende betaalmethoden aan.',
  nodatatip3: "Voeg goede foto's toe aan uw producten.",
  nodatatip4:
    'Maak uw productbeschrijvingen aantrekkelijk en gebruik SEO-technieken.',
  nodatatip5:
    'Investeer in betaald verkeer: advertenties op sociale netwerken en Google Shopping.',
  nodatatip6: 'Kijk of de prijs van uw producten aantrekkelijk is.',
  nodatatip7: 'Zorg voor een klantenservicekanaal om vragen te beantwoorden',
  nodatatips: '7 snelle tips om uw eerste verkoop te realiseren:',
  nodatatitle: 'Er zijn nog geen bestellingen om te tonen',
  nodeDescription: 'Triggerende situatiebeschrijving',
  nodeName: 'Triggerende situatie',
  operation: 'Status',
  order: 'Volgorde',
  orderCancel: 'Geannuleerd',
  orderClosed: 'Gesloten',
  orderConversion: 'Bestelstatus',
  orderConversionTipUnpaid:
    'Teruggewonnen via remarketing, maar nog niet betaald.',
  orderConversionTipUnconverted: 'Nooit door de klant betaald.',
  orderConversionTipPaid:
    'Teruggewonnen via remarketing en succesvol betaald.',
  orderConversionTipPending:
    'De klant is gestart met de betaling, maar heeft deze niet voltooid.',
  orderConversionTipPaidStatus: 'Betaling succesvol voltooid.',
  orderDeliver: 'Leveren',
  orderEnd: 'Voltooid',
  orderPaid: 'Betaald',
  orderReceived: 'Afgeleverd',
  orderToAnalyze:
    'Om de bronnen van verschillende bestellingen te analyseren en de advertenties tijdig aan te passen, zijn onze gegevens nauwkeuriger dan die op Facebook.',
  orderWaitPay: 'In behandeling',
  ordernum: 'Bestelnr',
  more: 'Meer',
  orderCodesBatchTips:
    'Voer één bestelnr per regel in, of scheid met komma\'s',
  ordertime: 'Besteltijd',
  originurl: 'Website-adres',
  originurlexample: 'Voorbeeld: jouw-winkel.myshopify.com',
  originurlprefix:
    'De URL mag de volgende waarden niet bevatten: www., https://, http://, /, .br',
  package:
    'Als de klant weigert het pakket te accepteren en om terugbetaling vraagt, komt de terugbetaling voor rekening van Partij B',
  partyAProvides:
    "Partij A biedt een terugbetalingsgarantieservice voor coöperatieve bestellingen tegen een vergoeding van 1,5%. Als wordt vastgesteld dat de reden voor de terugbetaling is dat de klant na ontvangst van het product ontevreden is over het product, worden de terugbetalingskosten gedragen door Partij A en hoeft Partij B de daarmee samenhangende verliezen niet te dragen. Voor specifieke gebruiksscenario's verwijzen wij u naar de bijlage van de systeemovereenkomst.",
  partyAProvidesconsumers:
    'Om de betalingsstabiliteit en naleving te garanderen, zal Partij A de enige aanbieder van after-salesdiensten voor Partij B zijn. Partij B zal Partij A volledig machtigen om alle after-saleszaken af ​​te handelen en toegang te verlenen tot de relevante e-mailaccount(s). Elke after-sales door Partij B is uitzonderlijk en vereist voorafgaande toestemming van Partij A, en in dergelijke gevallen zal Partij B Partij A volledige toegang verlenen tot de relevante after-sales e-mailaccount(s) voor realtime monitoring. Schending van deze clausule geeft Partij A het recht om de toegang van B tot betalingsdiensten onmiddellijk en zonder aansprakelijkheid op te schorten of te beëindigen.',
  partyProvides:
    'Partij A biedt partij B grensoverschrijdende internetbetalings- en afwikkelingsdiensten, waaronder:',
  password: 'Wachtwoord',
  payBy: 'BETAAL DOOR',
  payment: 'Betaling',
  paymentDateAnswer:
    'U kunt een herroeping aanvragen nadat u de orderverwerkingskosten heeft betaald. De opname wordt doorgaans binnen 1-2 werkdagen verwerkt. De uiteindelijke aankomsttijd is afhankelijk van uw bank.',
  paymentDateTitle:
    'Hoe lang duurt het voordat de opname wordt ontvangen nadat ik deze heb geïnitieerd?',
  paymentDomain: 'Domein CNAME opgelost',
  paymentRatesTitle: 'Betaling en tarieven voor elk land',
  paymentServicesToParty:
    'Partij A levert betalingsdiensten aan Partij B, en Partij B moet Partij A op de hoogte stellen van de inloggegevens van de winkel. Partij A voorziet Partij B ook van relevante transactie-informatie en diensten voor het opvragen van afwikkelingsinformatie, en Partij B moet samenwerken met Partij A om gezamenlijk de stabiliteit van de betaalproductrekening te handhaven.',
  paymentSetting: 'Betalingsinstellingen',
  paymentTime: 'Betalingstijd',
  paymentaffiliations: 'Betalingsinstellingen',
  paymentaffiliationsdesc:
    'De instellingen voor het uitvoeren van transacties in uw winkel en de taal- en landinstellingen voor de interface die aan klanten wordt weergegeven',
  shopifyCurrencyConfirmBRL:
    'Bevestig alstublieft dat de valuta van uw Shopify-winkel is ingesteld op BRL.',
  shopifyCurrencyConfirmCLP:
    'Bevestig alstublieft dat de valuta van uw Shopify-winkel is ingesteld op CLP.',
  shopifyCurrencyConfirmCOP:
    'Bevestig alstublieft dat de valuta van uw Shopify-winkel is ingesteld op COP.',
  shopifyCurrencyConfirmEUR:
    'Bevestig alstublieft dat de valuta van uw Shopify-winkel is ingesteld op EUR.',
  shopifyCurrencyConfirmGBP:
    'Bevestig alstublieft dat de valuta van uw Shopify-winkel is ingesteld op GBP.',
  shopifyCurrencyConfirmMXN:
    'Bevestig alstublieft dat de valuta van uw Shopify-winkel is ingesteld op MXN.',
  shopifyCurrencyConfirmPEN:
    'Bevestig alstublieft dat de valuta van uw Shopify-winkel is ingesteld op PEN.',
  shopifyCurrencyConfirmSEK:
    'Bevestig alstublieft dat de valuta van uw Shopify-winkel is ingesteld op SEK.',
  shopifyDomainUsedByOtherStore:
    'Dit domein is al gebruikt door een andere Shopify-winkel. Wijzig de status van alle ongebruikte Shopify-winkels naar "Inactive".',
  confirmStoreConnectedWiio:
    'Bevestig dat uw winkel is gekoppeld aan Wiio Dropshipping.',
  confirmStoreConnectedUsaDrop:
    'Bevestig dat uw winkel is gekoppeld aan USADrop Dropshipping.',
  paymentbtntext: 'Om op te zetten',
  paymentdoamin: 'Domein CNAME opgelost',
  paymentlanguage: 'Taal van betaalpagina',
  paymentoptions: 'Betalingsmogelijkheden',
  paymentoptionsdesc:
    'De betalingsopties die in uw winkel worden geaccepteerd.',
  paymenttitle:
    'Configureer de betaalmethoden die in uw winkel worden geaccepteerd.',
  personalInformationVerification: 'Verificatie van persoonlijke informatie',
  personalInformationVerificationSubTitle:
    'Bij informatieverificatie is uw mobiele telefoonnummer betrokken.',
  phone: 'Telefoonnummer',
  pixel: 'Pixel',
  pixelIDisRequired: 'Pixel-ID is vereist',
  pixelTokenisRequired: 'Pixeltoken is vereist',
  pixelexample:
    'Voorbeeld: Een klant ziet uw advertentie, bezoekt uw website en doet een aankoop. Pixel houdt dit bij, zodat u weet welke advertenties de meeste verkopen genereren.',
  pixelhelp:
    'Analyseer de prestaties van uw marketingcampagnes en bekijk hoe uw klanten omgaan met uw advertenties en uw winkel.',
  pixelid: 'Pixel ID',
  pixelname: 'Pixelnaam',
  pixeltoken: 'Pixeltoken',
  platforms: 'PLATFORMEN',
  pleaseFillTheRequiredFields: 'Vul de verplichte velden in',
  pleaseInput: 'Voer alstublieft in',
  pleaseInputDomain: 'Voer het domein in',
  pleaseSelect: 'Selecteer alstublieft',
  pleaseSelectDate: 'Selecteer een datum',
  pleconfirmPWD: 'Bevestig het wachtwoord',
  pleinputPWD: 'Voer het wachtwoord in',
  popup: 'Pop-up',
  popupBackground: 'Pop-upachtergrond',
  popupConfig: 'Pop-upconfiguratie',
  popupConfigDesc: 'Pop-upweergave-effect en pop-upregels',
  popupCycle: 'Pop-upcyclus',
  popupCycleItem: 'Nieuwe gebruiker, pop-up elke {input} dagen',
  preview: 'Voorbeeld',
  previousPage: 'Vorige pagina',
  priceTerms: 'Prijsvoorwaarden',
  privacypolicy: 'Privacybeleid',
  processingTime:
    'Partij A zal alle bestellingen uit de winkel van Partij B uitvoeren en de verwerkingstijd, verzendtijd, productbeschrijvingen in de winkel van Partij B, enz. bijwerken volgens de vereisten van Partij A. Als er aanpassingsartikelen zijn, zoals producten die niet op voorraad zijn en soortgelijke producten, moet partij B de aanpassing/verwijdering binnen 12 uur voltooien.',
  product: 'Product',
  productSpecifications:
    'Verkeerd product, kleur, maat, andere SPU, specificaties, terugbetalingen zijn voor rekening van Partij A',
  productsImitation:
    'Imitatieproducten_imitatiemerken, de terugbetaling komt voor rekening van Partij B',
  propertyRights:
    'Het uploaden en verkopen van producten die inbreuk maken op intellectuele eigendomsrechten is verboden',
  protocolBtnPrefix: 'Ik ga akkoord met de',
  protocolBtnTitle: 'Betalingsvoorwaarden en privacybeleid',
  protocolDialog: 'Gebruikersovereenkomst',
  questionsSupport:
    'Als u vragen heeft, kunt u ons onderstaande ondersteuningsmateriaal gebruiken:',
  recommendSize: 'Aanbevolen maat: {input}',
  recoverpassowrd: 'Wachtwoord herstellen',
  recovertitle: 'Vul hieronder uw e-mailadres in',
  rectifiedAccording:
    'Voor terugbetalingen van bestellingen die niet zijn gerectificeerd volgens de vereisten van Partij A, komt de terugbetaling voor rekening van Partij B.',
  redirectLink: 'Omleidingslink',
  refundGuaranteeFees: 'Garantiekosten terugbetalen',
  refundGuaranteeTerms: 'Voorwaarden voor terugbetalingsgarantie',
  refundShallBe:
    'Als het product niet wordt beoordeeld en het product niet op voorraad is, komt de terugbetaling voor rekening van Partij B',
  refundsAreBorne:
    'Uit logistieke informatie blijkt dat deze al geruime tijd niet is geleverd/bijgewerkt, restituties zijn voor rekening van Partij A',
  refundsAreGiven:
    'Het product is beoordeeld, het product is niet op voorraad en restituties worden aan de klant gegeven, restituties zijn ten laste van Partij A',
  register: 'Register',
  registersuccess: 'Succes registreren!',
  registertips:
    'We zullen uw gegevens gebruiken om uw toegangsaccount aan te maken en informatie te sturen waarmee u uw winkel kunt activeren.',
  requestNumber: 'BESTELNUMMER',
  requests: 'Volgorde',
  requestsCancellation:
    'De bestelling is niet verzonden en de klant vraagt ​​om annulering',
  save: 'Redden',
  saveFields:
    'Nadat u de velden heeft ingevuld, slaat u op wat u heeft ingevuld.',
  saveSuccessfully: 'Succesvol opslaan',
  search: 'Zoekopdracht',
  secondarydomains: 'Secundaire domeinen',
  selectCountry: 'Selecteer Land',
  selectTimeZone: 'Selecteer Tijdzone',
  service: 'Dienst',
  serviceemail: 'E-mail klantenservice',
  setUpDomain:
    'Stel uw domein in bij uw provider door de onderstaande stappen te volgen.',
  settings: 'Instellingen',
  settlementPeriod:
    'Verleng de verrekeningsperiode of schort de verrekening op; Partij A heeft het recht de Overeenkomst te beëindigen en niet terug te geven aan Partij B. Het openstaande bedrag en de borgsom worden na zes maanden op een ander overeengekomen tijdstip verrekend.',
  shipped:
    'De besteltijd is minder dan of gelijk aan 3 dagen, de bestelling is verzonden en de klant vraagt ​​om annulering en terugbetaling, en de terugbetaling komt voor rekening van Partij B',
  shopify: 'Shopify',
  shopifybtntext: 'Installeren',
  shopifytitle: 'Installeer Transparent Checkout in uw Shopify-winkel.',
  skipshoppingcart: 'Winkelmandje overslaan',
  specificRates: '3. Specifieke tarieven',
  specificUsageScenarios:
    "Terugbetalingen die via andere methoden worden gegenereerd, komen voor rekening van Partij A. Klik hier voor specifieke gebruiksscenario's",
  sslCertificate: 'SSL-CERTIFICAAT',
  start: 'Begin',
  startDate: 'Startdatum',
  startUsing: 'Actief',
  startconfig: 'Begin hier met configureren',
  status: 'Status',
  step1Content:
    '"Ga naar de website van uw domeinprovider. Zoek naar het configuratiegedeelte voor DNS-records."',
  step1Title: '"STAP 1: TOEGANG TOT UW PROVIDERSPANEEL"',
  step2Content:
    'Voeg bij uw provider in het configuratiegedeelte voor DNS-records de onderstaande informatie toe. Vul elk veld in met de onderstaande informatie:',
  step2Title: '"STAP 2: TOEGANG TOT UW PROVIDERSPANEEL"',
  step3Content:
    'Nadat u de bovenstaande gegevens correct heeft ingevuld bij uw domeinprovider, moet u een tijdje wachten totdat de informatie zich heeft verspreid. Dit proces duurt meestal maximaal 4 uur.',
  step3Title: 'STAP 3: WACHT OP PROPAGATIE',
  storeAccessingUrl: 'Adres van online winkel',
  storeBinding: 'Winkel aansluiten',
  storeBindingSettings: 'Instellingen opslaan',
  storeLogo: 'Winkellogo',
  storeLogoLimitTips: 'Aanbevolen formaat: 230*50, binnen 200 KB',
  orderImage: 'Winkelbestelvolume - Laatste 30 dagen',
  orderRemark: 'Bestelopmerking',
  orderImageLimitTips: 'Meerdere afbeeldingen worden ondersteund',
  viewExample: 'Voorbeeld bekijken',
  storename: 'Winkelnaam',
  termsofuse: 'gebruiksvoorwaarden',
  theCheckoutPage:
    'Kortingsbedrag/-percentage: Stel op de afrekenpagina een vast kortingsbedrag/-percentage in om klanten ertoe aan te zetten deze betaalmethode te kiezen.',
  theProductsSold:
    "De producten die op de website worden verkocht, omvatten producten die niet zijn geautoriseerd door het merk of die handelsmerken gebruiken die niet zijn geautoriseerd door het merk, evenals andere merkproducten; inbreuk op intellectueel eigendom zonder merknaam, inclusief maar niet beperkt tot: films, video's, liedjes, games, animatiewerken en hun randproducten, inclusief maar niet beperkt tot beeldjes, accessoires en karakteruitrusting.",
  theRefundShall:
    'Als de klant de goederen ontvangt en de levertijd te lang is en de winkeltijdlimiet niet overschrijdt, komt de terugbetaling voor rekening van Partij B',
  timezone: 'Tijdzone',
  tips: 'Tips',
  toEmbedPaymentMethods: 'Om betaalmethoden in te sluiten.',
  toenter: 'Om binnen te komen',
  tosave: 'Om op te slaan',
  total: 'Totaal',
  trackingNumber: 'Trackingnummer',
  transactionSettlement:
    'Partij B stemt ermee in dat Partij A de bovengenoemde kosten in mindering zal brengen op het transactiebedrag van Partij B.',
  transferPlatform: 'Platform voor orderoverdracht',
  tutorial: 'Handleiding',
  type: 'TYPE:',
  typeofintegration: 'Type integratie',
  typepassword: 'Typ uw wachtwoord',
  unauthorized:
    'Voor niet-geautoriseerde transacties wordt de terugbetaling gedragen door Partij B',
  unauthorizedTransaction: 'Ongeautoriseerde transactie',
  unconvertedOrder: 'Ongeconverteerde Orde',
  update: 'Om te updaten',
  urlDisplayed:
    'De URL die in de webbrowser wordt weergegeven wanneer klanten door uw online winkel bladeren, is een aangepaste domeinnaam.',
  usedNormally:
    'Kan niet normaal worden gebruikt, restituties zijn voor rekening van Partij A',
  value: 'WAARDE:',
  wantsToCancel: 'De klant koopt meer en wil annuleren en terugbetalen',
  whatisapixel: 'Wat is een pixel?',
  whatsAppTemplate: 'WhatsApp-sjabloon',
  whichTimeZoneSetTitle: 'Welke tijdzone moet worden ingesteld?',
  withdrawalFeeAnswer:
    'Het hangt af van uw bankkosten. Verschillende banken hanteren verschillende tarieven.',
  withdrawalFeeTitle: 'Wat zijn de kosten voor opnames?',
  withdrawalMethodAnswer:
    'Nadat u de afhandelingskosten heeft betaald, kunt u het portemonneesaldo opnemen. Bankoverschrijving en PayPal-opname worden ondersteund.',
  withdrawalMethodTitle:
    'Hoe kunt u contant geld opnemen en wat zijn de opnamemethoden?',
  yes: 'Ja',
  mismatched: 'Partij B',
  mustNotSell: 'mag geen merkartikelen verkopen,',
  brandIconsMust:
    'en merkpictogrammen mogen niet voorkomen in productbeschrijvingen. Zodra partij A constateert dat er een illegaal of niet-overeenkomend merkproduct in de winkel van partij B aanwezig is, zal partij A binnen zes uur alle betalingen aan de winkel van partij B opschorten en alle uitbetalingen stopzetten. Partij A heeft het recht om terugbetalingen te verwerken voor bestellingen die niet aan de voorschriften voldoen of deze overtreden, en alle kosten en uitgaven die daaruit voortvloeien worden uitsluitend gedragen door Partij B. Het specifieke boetebedrag wordt weergegeven in',
  theRefund: 'De terugbetalingsgarantieservice omvat het volgende:',
  refundGuarantee: 'Voorwaarden voor terugbetalingsgarantie.',
  priceList: 'Prijslijst',
  Holding: 'Vasthouden',
  appendixTwo: 'Bijlage 2.',
  paymentPriceList: 'Betaling prijslijst',
  howDoes: 'Wat is dropshipping en hoe werkt het?',
  whatIsPayment: 'Wat is USAdrop-betaling',
  differenceDropshipping: 'Het verschil tussen Rembours en Dropshipping',
  howsySterm: 'Hoe gebruik je het USAdrop-systeem?',
  howShopifyAPI: 'Shopify-API instellen',
  howDomain: 'Domein instellen',
  howPixel: 'Hoe stel je de Facebook-pixel in',
  howCoupon: 'Coupon instellen',
  pleaseShopifyStore:
    'Zorg ervoor dat het domein verbinding maakt met uw Shopify Store!',
  feeTerms: 'Tariefvoorwaarden',
  noRefundGuarantee: 'Geen restitutiegarantiekosten in Brazilië',
  deleteShopify:
    'Hoe u de dynamische knop "Nu kopen" en de knop "toevoegen aan winkelwagen" in Shopify kunt verwijderen of toevoegen',
  stepOne: 'Stap 1, navigeer naar "Online Winkel" → "Thema\'s" → "Aanpassen"',
  stepTwo:
    'Stap 2 - Navigeer naar "Producten" → "Standaardproduct" → voer de productbeschrijvingspagina in',
  stepThree:
    'Stap 3 - Klik op "Kopenknoppen" → Klik om "Dynamische afrekenknoppen weergeven" → "Opslaan" in te schakelen',
  dynamicCheckoutButton: 'Hoe u de dynamische afrekenknop instelt',
  personalInformationTitle: 'Mijn accountgegevens',
  personalInformationSubTitle:
    'Verificatie van accountgegevens is een proces om ervoor te zorgen dat uw gegevens juist en actueel zijn. Hierbij wordt uw telefoonnummer geverifieerd om er zeker van te zijn dat het correct en up-to-date is.',
  personalInformationTips: `Opmerking: 
Om de authenticiteit van uw identiteitsgegevens te garanderen, moeten we uw mobiele telefoonnummer verifiëren. De naam en het mobiele telefoonnummer kunnen na verificatie en binding niet worden gewijzigd. Als je de verificatiecode niet kunt ontvangen of deze moet wijzigen, neem dan contact op met de klantenservice/agent van USAdrop Payment.`,
  contactName: 'Contactnaam',
  contactPhone: 'Telefoonnummer',
  contactPhoneAreaCode: 'Telefoon netnummer',
  getVerificationCode: 'KRIJG VERIFICATIECODE',
  verificationCode: 'Verificatiecode',
  pleaseEnter: 'Voer alstublieft {invoer} in',
  pleaseSelect2: 'Selecteer alstublieft {invoer}',
  fulfillmentPlatform: 'Vervullingsplatform',
  pleaseEnterCorrect: 'Voer de juiste {input} in',
  sendSuccessfully: 'Verzenden is gelukt',
  submitSuccessfully: 'Succesvol indienen',
  serviceUnavailable: 'De dienst is niet beschikbaar',
  loginExpired: 'Login verlopen, log opnieuw in',
  toVerification: 'Naar verificatie',
  activeCustomerPaymentTips:
    'De verificatie van de persoonlijke gegevens is nog niet voltooid, dus de betaaldienst kan niet worden gebruikt.',
  activeCustomerPaymentTips2:
    "Klik op 'Verificatie van persoonlijke gegevens' om de verificatie van persoonlijke gegevens te voltooien.",
  skipCartTips1:
    'Deze functie helpt de conversiepercentages voor afzonderlijke bestellingen te verhogen, maar de tarieven voor het toevoegen aan winkelwagentje te verlagen. Schakel het indien nodig in.',
  skipCartTips2: `Indien geactiveerd, schakelt USAdrop Payment Shopify's "Toevoegen aan winkelwagen" uit 
knop en behoud alleen de dynamische betaalknoppen. Klanten 
Als u op deze knoppen klikt, wordt u rechtstreeks naar de kassa geleid 
pagina.`,
  skipCartTips3:
    "(Als de afrekenknop niet zichtbaar is op productpagina's nadat u deze functie hebt ingeschakeld, volgt u de tutorial om dynamische afrekenknoppen te activeren:",
  advertisingMaterial: 'Handleiding voor reclamemateriaal',
  violationRecord: 'Overtredingsregisters',
  store: 'Winkel',
  state: 'Staat',
  deadline: 'Termijn',
  needModified: 'Moet worden gewijzigd',
  reviewing: 'Beoordelen',
  completed: 'Voltooid',
  types: 'Type',
  picture: 'Afbeelding',
  details: 'Details',
  overdue: 'Verlopen',
  rejected: 'Afgewezen',
  operate: 'Bedienen',
  complete: 'Compleet',
  completeTips:
    'We staan ​​op het punt om de aanvraag ter beoordeling in te dienen. Zorg ervoor dat de wijzigingen zoals vereist zijn voltooid!',
  remark: 'Opmerking',
  remarkPlaceholder: 'Voer een opmerking in',
  pleaseInputRemark: 'Vul alstublieft de opmerking in',
  facebookPixel: 'Hoe Facebook Pixel instellen?',
  googlePixel: 'Hoe Google Pixel instellen?',
  themeColor: 'Thema Kleur',
  themeColorTips:
    'U kunt deze instelling gebruiken om de themakleur van de "afreken"-interface te wijzigen.',
  buttonColor: 'Koop nu Kleur',
  buttonColorTips:
    "U kunt deze instelling gebruiken om de kleur van de knop 'Nu kopen' te wijzigen.",
  terminationAgreement: 'Beëindiging van de overeenkomst',
  installment: 'Afbetaling',
  unhandledStores: 'Je hebt illegale winkels',
  pixelTop1: 'GTM is al gekoppeld. Je kunt geen extra pixel toevoegen.',
  pixelTop2: 'Schakel de huidige pixel uit voordat u GTM gebruikt.',
  pixelTop3:
    'GTM en andere pixels kunnen niet tegelijkertijd werken. Hulp nodig? Neem contact op met uw makelaar.',
  successVideoTop: 'Echte succesverhalen',
  paypalTop:
    'Neem contact op met onze agent om de Paypal-betaling te activeren.',
  errorMessage: 'Er is een serverfout opgetreden',
  wiioRechargeTitle: 'Herinnering',
  wiioRechargeDesc:
    'Betaal het maandelijkse bedrag om het platform te gebruiken.',
  wiilRechargeConfirm: 'Ga naar USAdrop',
  orderPageDesigner: 'Checkout-editor',
  export: 'Exporteren',
  exporting: 'Exporteren...',
  unknownError: 'Onbekende fout',
  downloadSuccess: 'Downloaden gelukt',
  defaultExportNotice:
    'Standaard worden logboeken van de afgelopen 30 dagen geëxporteerd; u kunt een maximaal bereik van 30 dagen selecteren',
  pageStyleConfig: 'Configuratie van paginastijl',
  reset: 'Opnieuw instellen',
  limitedTimeOffer:
    'Tijdelijke aanbieding! Bestel nu en profiteer van de korting!',
  countdownToEnd: 'Tijd tot het evenement eindigt:',
  configLoadedSuccess: 'Configuratiegegevens zijn succesvol geladen',
  configLoadedUseDefault:
    'Kan configuratiegegevens niet laden met gebruik van standaardwaarden',
  configLoadFailed:
    'Kan de configuratie niet ophalen. Controleer het netwerk of de service',
  confirmRestore:
    'Weet u zeker dat u de configuratie wilt herstellen? Deze actie is onomkeerbaar',
  warning: 'Waarschuwing',
  confirmReset: 'Bevestig het resetten',
  submitSuccess: 'Succesvol ingediend',
  checkoutConfigSaved:
    'Configuratie van de afrekenpagina is opgeslagen en succesvol toegepast!',
  saveConfigFailed:
    'Kan de configuratie niet opslaan. Probeer het later opnieuw.',
  visualSizeConfig: 'Visuele en maatconfiguratie',
  width: 'Breedte',
  height: 'Hoogte',
  textAndCountdownConfig: 'Tekst- en aftelconfiguratie (marketingkopie)',
  textContent: 'Tekstinhoud',
  enterMarketingCopy: 'Voer een marketingtekst in',
  fontSize: 'Lettergrootte',
  fontColor: 'Lettertypekleur',
  fontWeight: 'Lettertype gewicht',
  selectWeight: 'Selecteer gewicht',
  countdownSettings: 'Aftelinstellingen',
  enableCountdown: 'Aftellen inschakelen',
  countdownPrefix: 'Aftelvoorvoegsel',
  examplePrefix: 'Voorbeeld: Tot einde',
  endTime: 'Eindtijd',
  selectEndTime: 'Selecteer de eindtijd van het aftellen',
  textSpacing: 'Tekst-/timerafstand',
  realtimePreview: 'Realtime voorbeeld',
  eventEnded: 'Het evenement is afgelopen',
  rowInfo: 'Rij {index} Informatie',
  icon: 'Icon',
  title: 'Titel',
  bottomTextConfig: 'Onderste tekstconfiguratie',
  text: 'Tekst',
  suggestedSize: 'Aanbevolen maat',
  logo: 'Logo',
  banner: 'Banier',
  safetyInfo: 'Veiligheidsinformatie',
  securityIcons: 'Beveiligingspictogrammen',
  description: 'Beschrijving',
  confirmSavePageStyle:
    'Weet u zeker dat u de huidige paginastijlconfiguratie wilt opslaan? Eenmaal opgeslagen, wordt het onmiddellijk van kracht op de afrekenpagina.',
  getCodeTip:
    'Vul eerst het winkeldomein, de API-sleutel en de geheime sleutel in.',
  getCode: 'Ontvang code',
  token_helper_tip:
    'Ontvang automatisch een toegangstoken via de inloggegevens van het Dev Dashboard.',
  copySuccess: 'Gekopieerd!',
  paymentDetails: 'Betaalgegevens',
  viewPaymentCode: 'Betaalcode',
  paymentLink: 'Betaallink',
  paymentCodeDetails: 'Betaalcode',
  barcode: 'Barcode',
  pixPaymentCode: 'PIX-betaalcode',
  copyPaymentCode: 'Betaalcode kopiëren',
  downloadPaymentImage: 'Afbeelding downloaden',
  paymentCodeValidUntil: 'Geldig tot',
  paymentImageUnavailable: 'De betaalafbeelding kon niet worden gegenereerd.',
  copyFailed: 'Kopiëren is mislukt. Selecteer en kopieer de code handmatig.',
  pleaseFillInClientIdAndSecret:
    'Vul de client-ID (API-sleutel) en geheim (API-geheime sleutel) in',
  pleaseEnterClientIdAndSecret:
    'Voer de klant-ID (API-sleutel) en geheim (geheime API-sleutel) in',
  pleaseFillInClientIdAndSecretFirst:
    'Vul eerst de Client ID (API Key) en Secret (API Secret Key) in',
  pleaseContactAgent: 'Neem contact op met makelaar',
  createStoreMexicoUSAdropPaymentsTitle: 'Bouw uw Shopify-winkel vanaf 0',
  couponDisplayConfig: 'Couponweergave',
  displayMode: 'Weergavemodus',
  couponDisplayExpand: 'Uitbreiden',
  couponDisplayHide: 'Verbergen',
  couponHideModeTipStart:
    'Wanneer ingeschakeld, is het invoerveld voor kortingscodes standaard verborgen. Als je een',
  couponHideModeTipEnd:
    'hebt ingesteld en deze actief is, wordt deze automatisch toegepast wanneer een klant een tweede bestelling plaatst. Als je niet wilt dat klanten kortingscodes gebruiken, zet de couponstatus dan op "Uitgeschakeld".',
  couponDisplayCollapse: 'Instorten',
  couponUnselected: 'Niet geselecteerd',
  couponNoAvailable: 'Geen beschikbare kortingsbonnen',
  couponNoCode: 'Niet verplicht in te vullen',
  productPrice: 'Product',
  productDiscount: 'Korting',
  productShipping: 'Verzending',
  free: 'Vrij',
  apply: 'Toepassen',
  orderPreviewPriceProduct: '$ 9999,00',
  orderPreviewPriceDiscount: '-$ 0,00',
  orderPreviewPriceTotal: '$ 9999,00',
  uponTransactionRisks:
    "Wanneer de consument een terugbetalingsverzoek indient, behoudt Partij A zich het recht voor om een ​​terugbetaling voor de transactie te verwerken om ernstigere transactierisico's te beperken.",
  howGooglePixel: 'Hoe stel je de Google Pixel in',
  fulfillmentPlatformTips: 'Belangrijk: Bestellingen pagas via onze betaaloplossing moeten via onze fulfilmentdienst worden verwerkt.',
  shippingCalculation: 'Verzendkostenberekening inschakelen',
  shippingCalculationTips: 'Bereken en controleer de verzendkosten tijdens het afrekenen.'
}
